
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class QuotationLaborGrid extends Serenity.EntityGrid<SalesQuotationLaborRow, any> {
        protected getColumnsKey() { return 'Sales.QuotationLabor'; }
        protected getIdProperty() { return SalesQuotationLaborRow.idProperty; }
        protected getInsertPermission() { return SalesQuotationLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesQuotationLaborRow.localTextPrefix; }
        protected getService() { return SalesQuotationLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}